import { Outlet } from 'react-router-dom';
import { Header } from '@/components/stashstr/Header';
import { Footer } from '@/components/stashstr/Footer';

export function AppLayout() {
  return (
    <div className="min-h-screen bg-white dark:bg-[#111214] flex flex-col">
      <Header />
      <main className="max-w-3xl w-full mx-auto px-3 py-4 flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
